import React, { useState } from 'react'
import ReactMapGL, { Marker } from "react-map-gl";
import CommonModal from '../../UiKits/Modals/common/modal'
import { H5, P } from '../../../AbstractElements';
import { Descriptions } from 'antd';
import { useLocation } from 'react-router';
import { removeSearchParams } from '../../../utils';

const ActivityDetail = ({ activity: { details, show }, setActivity }) => {
  const location = useLocation();
  const [Viewport, setViewport] = useState({
    width: "100%",
    height: "100%",
    latitude: details.coordination?.lat,
    longitude: details.coordination?.long,
    zoom: 12,
  });

  const renderDetailsItem = (label, content) => (
    <Descriptions.Item label={<span>{label}</span>}>
      <span>{content}</span>
    </Descriptions.Item>
  );

  const renderTransferDetails = () => (
    <Descriptions.Item label={<span>Params Data</span>}>
      <p>
        <span>
          <b>Transfer From : </b>{details.fromCourse.courseName} course{' '}
          {details.fromCourse.module ? details.fromCourse.module + ' module' : ''}
        </span>
        <span>
          {' '}
          To {details.toCourse.courseName} course{' '}
          {details.toCourse.module ? details.toCourse.module + ' module' : ''}
        </span>
      </p>
    </Descriptions.Item>
  );

  const renderCourseValue = () => (
    <Descriptions.Item label={<span>Course Value</span>}>
      <span>
        {Object.keys(details.oldData).map((key) => (
          <p key={key}>
            <b>{key}</b> : <span>{String(details.oldData[key])}</span>{' '}
            {String(details.newData[key])}
          </p>
        ))}
      </span>
    </Descriptions.Item>
  );

  const closeActivity = () => {
    removeSearchParams(location);
    setActivity({
      show: false,
      details: {}
    })
  }

  return (
    <CommonModal
      isOpen={show}
      toggler={() => closeActivity()}
      showCloseBtn={true}
      successText={'Close'}
      title='Activity Details'
      success={() => closeActivity()}
      bodyClass='full-screen-modal'
      size="lg"
    >
      <Descriptions bordered column={1}>
        {renderDetailsItem('Admin Email', details.adminId)}
        {renderDetailsItem('Student Email', details.activityOnUser ?? 'N/A')}
        {renderDetailsItem('Activity', details?.acivity || details?.activity)}
        {details?.coordination?.long && renderDetailsItem('Longitude', details.coordination?.long)}
        {details?.coordination?.lat && renderDetailsItem('Latitude', details.coordination?.lat)}
        {details?.browserName && renderDetailsItem('Browser Name', details?.browserName)}
        {details?.osName && renderDetailsItem('OS Name', details?.osName)}
        {details?.courseName && renderDetailsItem('Course Name', details?.courseName)}
        {details?.courseType && renderDetailsItem('Course Type', details?.courseType)}
        {details?.courseId && renderDetailsItem('Course Id', details?.courseId)}
        {details.fromCourse && renderTransferDetails()}
        {Object.keys(details.oldData ?? {}).length && renderCourseValue()}

        {details?.coordination?.lat && (
          <Descriptions.Item label={<span>Location</span>}>
            <div className='mapbox-gl'>
              <ReactMapGL
                mapStyle='mapbox://styles/muzammil144/ckth155c31as017qfkormprrh'
                mapboxApiAccessToken='pk.eyJ1IjoibXV6YW1taWwxNDQiLCJhIjoiY2tzMmMyamttMWt6NzJwbzlmMWc4ZWU4eiJ9.fE1faL8Jrv3EybndaO30LA'
                {...Viewport}
                onViewportChange={(nextViewPort) => setViewport(nextViewPort)}
              >
                <Marker
                  longitude={details.coordination.long}
                  latitude={details.coordination.lat}
                  offsetLeft={-20}
                  offsetTop={-10}
                >
                  <p role='img' className='cursor-pointer text-2xl animate-bounce' aria-label='pin'>
                    📍
                  </p>
                </Marker>
              </ReactMapGL>
            </div>
          </Descriptions.Item>
        )}
      </Descriptions>
    </CommonModal >
  )
}

export default ActivityDetail